import type { ContentTypeName } from "@content-types"

export const defaultDashboardContentType: ContentTypeName = "news"
export const defaultDashboardPath = "/dashboard/news"
export const dashboardUsersPath = "/dashboard/users"
export const dashboardUtilitySections = ["users"] as const
export type DashboardUtilitySection = (typeof dashboardUtilitySections)[number]
export type DashboardSection = ContentTypeName | DashboardUtilitySection

export const dashboardContentTypePaths: Record<ContentTypeName, string> = {
  news: "/dashboard/news",
  careers: "/dashboard/careers",
  workProducts: "/dashboard/work-products",
  workMarketing: "/dashboard/work-marketing",
  workTags: "/dashboard/work-tags",
  companyHistory: "/dashboard/company-history",
}

export const dashboardPathSegmentsByContentType: Record<ContentTypeName, string> = {
  news: "news",
  careers: "careers",
  workProducts: "work-products",
  workMarketing: "work-marketing",
  workTags: "work-tags",
  companyHistory: "company-history",
}

const contentTypesByDashboardPathSegment = Object.fromEntries(
  Object.entries(dashboardPathSegmentsByContentType).map(([type, segment]) => [
    segment,
    type as ContentTypeName,
  ])
) as Record<string, ContentTypeName>

export function dashboardPathForContentType(type: ContentTypeName): string {
  return dashboardContentTypePaths[type] ?? defaultDashboardPath
}

export function dashboardContentTypeFromPathSegment(segment: string | undefined): ContentTypeName | null {
  if (!segment) return null
  return contentTypesByDashboardPathSegment[segment] ?? null
}

export function dashboardSectionFromPathSegment(segment: string | undefined): DashboardSection | null {
  const contentType = dashboardContentTypeFromPathSegment(segment)
  if (contentType) return contentType
  if (segment === "users") return "users"
  return null
}

export function dashboardPathForSection(section: DashboardSection): string {
  if (section === "users") return dashboardUsersPath
  return dashboardPathForContentType(section)
}
